var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "performance flex-container" }, [
    !_vm.isDataLoaded
      ? _c("div", [_vm._v(_vm._s(_vm.$t("loading")))])
      : _c(
          "div",
          { staticClass: "flex-col flex-1 reverse performance-content" },
          [
            !_vm.isInEditMode
              ? _c("div", { staticClass: "flex-row" }, [
                  _c("div", { staticClass: "flex-col flex-1 label mr-3" }, [
                    _vm._v(_vm._s(_vm.$t("comment")) + ": "),
                  ]),
                  _c("div", { staticClass: "flex-col flex-8 comment" }, [
                    _vm._v(_vm._s(_vm.comment)),
                  ]),
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "flex-row mb-1",
                class: { "perf-charts": _vm.isNewUi },
              },
              [
                _c("div", { staticClass: "flex-col flex-10" }, [
                  _vm.isDataLoaded
                    ? _c(
                        "div",
                        { staticClass: "flex-row flex-justify-center mt-2" },
                        [
                          _vm.kpiType === "A"
                            ? _c("KpiA", {
                                attrs: {
                                  kpiAData: _vm.chartData,
                                  serialNumber: _vm.serialNumber,
                                  yearLabel: _vm.yearLabel,
                                },
                              })
                            : _vm.kpiType === "B"
                            ? _c("KpiB", {
                                attrs: {
                                  kpiBData: _vm.kpiresult.data.typeBC[0],
                                  asset: _vm.asset,
                                  serialNumber: _vm.serialNumber,
                                  yearLabel: _vm.yearLabel,
                                },
                              })
                            : _vm.kpiType === "C"
                            ? _c("KpiC", {
                                attrs: {
                                  chartData: _vm.chartData,
                                  asset: _vm.asset,
                                  serialNumber: _vm.serialNumber,
                                  yearLabel: _vm.yearLabel,
                                },
                              })
                            : _vm.kpiType === "D" && !_vm.isInEditMode
                            ? _c("KpiD", {
                                attrs: { chartData: _vm.chartData },
                              })
                            : _vm.kpiType === "D" && _vm.isInEditMode
                            ? _c("KpiDEdit", {
                                attrs: { chartData: _vm.chartData },
                                on: { "type-d-values": _vm.getTypeDValues },
                              })
                            : _c("div", { staticClass: "blank-height" }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.kpiType &&
                  (_vm.kpiType === "A" ||
                    _vm.kpiType === "B" ||
                    _vm.kpiType === "C" ||
                    _vm.kpiType === "D")
                    ? _c("div", [
                        _vm.isInEditMode
                          ? _c("div", { staticClass: "flex-row" }, [
                              _c(
                                "div",
                                { staticClass: "flex-col flex-1 edit-comment" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "mt-1 perf-comment" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "perf-label",
                                          attrs: { for: "comment" },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("comment")))]
                                      ),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.comment,
                                            expression: "comment",
                                          },
                                        ],
                                        staticClass: "comment-input",
                                        attrs: {
                                          id: "comment",
                                          placeholder: _vm.$t("comment"),
                                          maxlength: "500",
                                          rows: "4",
                                        },
                                        domProps: { value: _vm.comment },
                                        on: {
                                          keyup: function ($event) {
                                            return _vm.updateComponentInRealTime()
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.comment = $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "mt-3 perf-comment" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "perf-label",
                                          attrs: { for: "updComment" },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("reason")))]
                                      ),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.updComment,
                                            expression: "updComment",
                                          },
                                        ],
                                        staticClass: "comment-input",
                                        attrs: {
                                          id: "updComment",
                                          placeholder: _vm.$t("reason"),
                                          maxlength: "250",
                                          rows: "4",
                                        },
                                        domProps: { value: _vm.updComment },
                                        on: {
                                          keyup: function ($event) {
                                            return _vm.updateComponentInRealTime()
                                          },
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.updComment = $event.target.value
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      class: _vm.errorExists
                                        ? "error-text"
                                        : "",
                                    },
                                    [
                                      _vm.errorExists
                                        ? _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("thisFieldIsMandatory")
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }